/* React */
import { Box } from '@auviknetworks/iceberg-ui';
import { MuiMarkdown, getOverrides } from 'mui-markdown';
import React from 'react';

export const Markdown = ({ content }: { content: string }) => (
    <Box data-testid="markdown">
        <MuiMarkdown
            overrides={{
                ...getOverrides(),
                li: {
                    component: 'li',
                    props: {
                        className: 'markdown-li'
                    }
                },
                ul: {
                    component: 'ul',
                    props: {
                        className: 'markdown-ul'
                    }
                }
            }}
        >
            {content}
        </MuiMarkdown>
    </Box>
);
